$(function () {
    var $b = $('body');
    var classKey = 'fontSizeClass';
    var classes = 'size-small size-large';

    function setActive(val) {
        $('.js-font').removeClass('active')
            .filter(function () { return ($(this).attr('data-body-class') || '') === val; })
            .addClass('active');
    }

    function apply(val) {
        $b.removeClass(classes);
        if (val) $b.addClass(val);
        setActive(val);
    }

    $(document).on('click', '.js-font', function (e) {
        e.preventDefault();
        var cls = $(this).attr('data-body-class') || '';
        apply(cls);
        cls ? localStorage.setItem(classKey, cls) : localStorage.removeItem(classKey);
    });

    var saved = localStorage.getItem(classKey) || '';
    apply(saved);
});
